import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import { Box, Skeleton, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

const RevenueAreaChart = ({ tab }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const trend = useSelector((state) => state.pointTracker[tab].data);
  const trendLoading = useSelector((state) => state.pointTracker[tab].loading);

  const [series, categories] = useMemo(() => {
    let sales = [];
    let revenue = [];
    let months = [];
    trend?.trends?.forEach((trend) => {
      sales.push(trend.sales);
      revenue.push(trend.revenue);
      months.push(trend.month);
    });
    return [
      [
        {
          name: 'Sales',
          data: sales,
        },
        {
          name: 'Revenue',
          data: revenue,
        },
      ],
      months,
    ];
  }, [trend]);

  const options = {
    chart: {
      type: 'area',
      fontFamily: 'inherit',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    colors: ['#A855F7', '#06B6D4'],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.1,
        stops: [0, 90, 100],
      },
    },
    xaxis: {
      categories,
      axisBorder: {
        show: true,
        color: '#e0e0e0',
      },
      axisTicks: {
        show: true,
      },
      labels: {
        style: {
          colors: '#64748b',
        },
      },
    },
    yaxis: {
      tickAmount: 4,
      labels: {
        style: {
          colors: '#64748b',
        },
        formatter: (value) => {
          return value.toFixed(0);
        },
      },
    },
    grid: {
      borderColor: '#e2e8f0',
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      markers: {
        radius: 12,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 0,
      },
    },
  };

  return (
    <Box
      sx={{
        overflow: isSm ? 'auto' : 'hidden',
      }}
    >
      {trendLoading ? (
        <Skeleton height={400} width={isSm ? 600 : '100%'} />
      ) : (
        <Chart options={options} series={series} type="area" height={400} width={isSm ? 600 : '100%'} />
      )}
    </Box>
  );
};
export default React.memo(RevenueAreaChart);
